import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-price-resize',
  templateUrl: './price-resize.component.html',
  styleUrls: ['./price-resize.component.scss']
})
export class PriceResizeComponent implements OnInit {
  /**
  Notas de uso:
  Este componente cambiará el tamaño de la fuente diferenciando decimales de enteros.
  El valor ingresa por el setter Value.

  Con el set intIncreaseValue podremos especificar cuanto CRECERÁ en PX la parte entera del número
  Con el set floatDecreaseValue podremos especificar cuanto DISMINUIRÁ en PX la parte decimal del número

  IMPORTANTE: Para usar este componente es OBLIGATORIO pasar primero el valor por la pipe de precio o toneladas.
  De lo contrario la separacion de coma no existirá y ni el valor ni el tamaño tendrán cambios
  IMPORTANTE: usar este componente puede romper ciertas alineaciones css
  **/

  @Input() set value(val: string) {
    if (val === undefined || val === null) {
      val = '';
    }
    if (val.indexOf(',') !== -1) {
      this.mExists = val.indexOf('M') !== -1;
      const parts = val.split(',');
      this.big = parts[0] + ',';
      this.small = parts[1];
      if (this.mExists) {
        // quitamos la M de los decimales
        this.small = this.small.slice(0, -1);
      }
      this.untouched = '';
    } else {
      this.untouched = val;
    }
  }

  private big = '';
  private small = '';
  private untouched = '';
  private mExists = false;

  private increaseVal = 'calc(100%)';
  private decreaseVal = 'calc(100%)';

  @Input() set intIncreaseValue (val: number) {
    /** cantidad que creceran los valores Int **/
    this.increaseVal = `calc(100% + ${val}px)`;
  }
  @Input() set floatDecreaseValue (val: number) {
    /** cantidad que disminuiran los valores Int **/
    this.decreaseVal = `calc(100% - ${val}px)`;
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/price-resize/price-resize.component.ts